/**
 * Custom breakpoint sizes for MerchandiseMegaMenu
 *
 * These are generated using the same pattern as buildMediaQueryDown from breakpoint.ts
 * to maintain consistency with the codebase's breakpoint system.
 */
export const merchandiseMegaMenuBreakpoints = {
  /**
   * @media (max-width: 1637.98px)
   * Ultra-wide screens: reduces panel width to prevent excessive whitespace
   */
  ultraWide: '@media (max-width: 1637.98px)',

  /**
   * @media (max-width: 1279.98px)
   * Medium-large screens: adjusts layout, reducing grid columns and padding
   */
  mediumLarge: '@media (max-width: 1279.98px)',

  /**
   * @media (max-width: 1099.98px)
   * Compact screens: compact layout for smaller desktop screens
   */
  compact: '@media (max-width: 1099.98px)',

  /**
   * @media (max-width: 991.98px)
   * Tablet screens: matches standard tablet breakpoint
   */
  tablet: '@media (max-width: 991.98px)',
} as const

export type MerchandiseMegaMenuBreakpoint = keyof typeof merchandiseMegaMenuBreakpoints
